<script lang="ts">
  import Dialog from "components/Common/Dialog.svelte";
  import { ConflictError, getCollection } from "services/collections/api";
  import { useUpdateCollectionMutation } from "./collectionOperations";
  import { notify } from "services/notifications";

  export let collectionId: string;

  let collectionName = "";
  let nameConflict = false;

  const updateCollectionMutation = useUpdateCollectionMutation();

  $: if (collectionId) {
    getCollection(collectionId)
      .then((collection) => {
        collectionName = collection.metadata.displayName || collection.name;
        nameConflict = false;
      })
      .catch(() => {
        collectionName = "";
        nameConflict = false;
        notify("Kunne ikke hente samlingsdetaljer", "error", 5000);
      });
  }

  async function onConfirm(): Promise<void> {
    try {
      await $updateCollectionMutation.mutateAsync({
        collectionId,
        newName: collectionName,
      });
    } catch (error) {
      if (error instanceof ConflictError) {
        nameConflict = true;
      }
      throw error;
    }
  }
</script>

<Dialog
  id="edit-collection-dialog"
  headerText={"Rediger samling"}
  confirmText={"Lagre"}
  {onConfirm}
  confirmDisabled={!collectionName.trim()}
>
  <h3>Velg egenskaper</h3>
  <label for="collection-name">Navn</label>
  <input
    class="org-input"
    style="margin-bottom: var(--org-xsmall)"
    id="collection-name"
    type="text"
    placeholder="Mine favoritter"
    aria-invalid={nameConflict}
    on:input={() => (nameConflict = false)}
    bind:value={collectionName}
  />
  {#if nameConflict}
    <span class="org-warning">En samling med dette navnet finnes allerede</span>
  {/if}
</Dialog>
